
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29.667","height":"29.667","viewBox":"0 0 29.667 29.667"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.833 27.194A12.361 12.361 0 102.472 14.833a12.4 12.4 0 0012.361 12.361z","stroke":"#26a69a","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","fill":"none"}}),_c('path',{attrs:{"d":"M9.58 14.835l3.5 3.5 7.009-7","opacity":".34","stroke":"#26a69a","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","fill":"none"}})])
          )
        }
      }
    